import React from 'react'
import { connect, mapStateToProps } from '../../../helpers/Common'
import WhatsappOverlayComponent from './WhatsappOverlayComponent'

function WhatsappOverlay({ redux }) {
  return (
    <>
      {!redux.profile.supervisor_groups ? <WhatsappOverlayComponent /> : ''}
    </>
  )
}

export default connect(mapStateToProps)(WhatsappOverlay)